import { ApiProperty } from "@nestjs/swagger";

export class EmployeeDto {
    id: number
    employeeName: string;
    division: number;
    unit: string;
    role: number;
    refNo: string;
    contactNumber: string;
    address: string;
    gpsLocation: string;
    isActive: boolean;
    createdUser: string | null;
    updatedUser: string | null;
    versionFlag: number;
    departmentName: number;
    plantId: number;

    constructor(id: number,
        employeeName: string,
        departmentName: number,
        division: number,
        unit: string,
        role: number,
        refNo: string,
        contactNumber: string,
        address: string,
        gpsLocation: string,
        isActive: boolean,
        createdUser: string | null,
        updatedUser: string | null,
        versionFlag: number,plantId: number){
            this.id=id;
            this.employeeName=employeeName;
            this.departmentName= departmentName;
            this.division=division;
            this.unit=unit;
            this.role = role;
            this.refNo = refNo
            // this.from=from;
            // this.to=to;
            // this.noofpeople=noofpeople;
            this.contactNumber=contactNumber;
            this.address = address;
            this.gpsLocation = gpsLocation;
            this.isActive=isActive;
            this.createdUser=createdUser;
            this.updatedUser=updatedUser;
            this.versionFlag=versionFlag;
            this.plantId=plantId;

        }




}